module.exports = __webpack_public_path__ + "img/CM0030_hamster.52087e5f.png";